import React from 'react';
import { Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import HomePage2 from '../HomePage2/HomePage2';
import HomePage3 from '../HomePage3/HomePage3';
import AboutUsPage from '../AboutUsPage/AboutUsPage';
import PricingPage from '../PricingPage/PricingPage';
import PortfolioPage from '../PortfolioPage/PortfolioPage';
import PortfolioSinglePage from '../PortfolioSinglePage/PortfolioSinglePage';
import TeamPage from '../TeamPage/TeamPage';
import TeamSinglePage from '../TeamSinglePage/TeamSinglePage';
import ServicePage from '../ServicePage/ServicePage';
import ServiceXNovaQPage from '../ServicePage/ServiceXNovaQ';
import ContingentStaffing from '../ServicePage/ContingentStaffing';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import NearShoreStaffing  from '../ServicePage/NearShoreStaffing';
import BlogPage from '../BlogPage/BlogPage';
import BlogDetails from '../BlogDetails/BlogDetails';
import ContactPage from '../ContactPage/ContactPage';
import ThankYou from '../../components/ThanksScreen/Thanks';
import ServiceHome from '../ServicePage/ServiceHome';
import RecruitmentProcess from '../ServicePage/RecruitmentProcess';
// import Courses from '../components/Courses/courses';
import HomeStyle2 from '../../components/HomePage/components/Pages/HomeStyle2';
import LetsTalk from '../LetsTalk/LetsTalk';



const AllRoute = () => {

  return (
    <div className="App">
        <Routes>
          <Route path="/" element={<HomeStyle2 />} />
          {/* <Route path="/" element={<HomeStyle2 />} /> */}
          <Route path="kodo-program" element={<Homepage />} />
          <Route path="home_software_company" element={<HomePage2 />} />
          <Route path="home_business_consulting" element={<HomePage3 />} />
          <Route path="course" element={<HomePage3 />} />
          <Route path="service-XnovaQ" element={<ServiceXNovaQPage />} />
          <Route path="Contingent-Staffing" element={<ContingentStaffing />} />
          <Route path="Near-Shore-Staffing" element={<NearShoreStaffing />} />
          <Route path="Recruitment-Process" element={<RecruitmentProcess />} />
          <Route path="Service-Home" element={<ServiceHome />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route path="portfolio_details/:slug" element={<PortfolioSinglePage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="team-single/:slug" element={<TeamSinglePage />} />
          <Route path="service" element={<ServicePage />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-single/:slug" element={<BlogDetails />} />
          <Route path="contact" element={<ContactPage />} />  
          <Route path="thanks" element={<ThankYou />} />  
          <Route path="lets-talk" element={<LetsTalk />} />  

          {/* <Route path="courses" element={<Courses />} /> */}
        </Routes>

    </div>
  );
}

export default AllRoute;
